import { UserManager, UserManagerSettings } from "oidc-client-ts";

import { OidcEventHandler } from "./oidc-event-handler";
import { autoinject } from "aurelia-framework";
import Infrastructure from "./infrastructure";

@autoinject
export class OidcConfiguration {
  private _oidcEventHandler: OidcEventHandler;
  private _userManager: UserManager;

  public constructor(oidcEventHandler: OidcEventHandler) {
    this._oidcEventHandler = oidcEventHandler;
    this._userManager = new UserManager(this.configureOidcClient());
  }

  public configureOidcClient() {
    let redirectUri = `${window.location.origin}/signin-oidc`;
    let authority = Infrastructure.authorityUrl;
    let userManagerSettings: UserManagerSettings = {
      authority,
      post_logout_redirect_uri: redirectUri,
      redirect_uri: redirectUri,
      client_id: "Axxess-Identity-Frontend-Core",
      response_type: "code",
      scope: "openid email profile"
    };
    return userManagerSettings;
  }

  public createUserManager() {
    this._oidcEventHandler.attach(this._userManager);
    return this._userManager;
  }
}
